<template>
  <div>
    <h1>Edit {{ item && item['@id'] }}</h1>

    <div
      v-if="created"
      class="alert alert-success"
      role="status">{{ created['@id'] }} created.</div>
    <div
      v-if="updated"
      class="alert alert-success"
      role="status">{{ updated['@id'] }} updated.</div>
    <div
      v-if="isLoading || deleteLoading"
      class="alert alert-info"
      role="status">Loading...</div>
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ error }}
    </div>
    <div
      v-if="deleteError"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ deleteError }}
    </div>

    <EXSBPeriodTypeForm
      v-if="item"
      :handle-submit="onSendForm"
      :handle-update-field="updateField"
      :values="item"
      :errors="violations"
      :initial-values="retrieved" />

    <router-link
      v-if="item"
      :to="{ name: 'EXSBPeriodTypeList' }"
      class="btn btn-default">Back to list</router-link>
    <button
      class="btn btn-danger"
      @click="del">Delete</button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXSBPeriodTypeForm from './Form.vue'

export default {
  components: {
    EXSBPeriodTypeForm
  },

  data () {
    return {
      item: {}
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'exsbperiodtype/update/isLoading',
      error: 'exsbperiodtype/update/error',
      deleteError: 'exsbperiodtype/del/error',
      deleteLoading: 'exsbperiodtype/del/isLoading',
      created: 'exsbperiodtype/create/created',
      deleted: 'exsbperiodtype/del/deleted',
      retrieved: 'exsbperiodtype/update/retrieved',
      updated: 'exsbperiodtype/update/updated',
      violations: 'exsbperiodtype/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXSBPeriodTypeList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'exsbperiodtype/create/reset',
      deleteItem: 'exsbperiodtype/del/del',
      delReset: 'exsbperiodtype/del/reset',
      retrieve: 'exsbperiodtype/update/retrieve',
      updateReset: 'exsbperiodtype/update/reset',
      update: 'exsbperiodtype/update/update',
      updateRetrieved: 'exsbperiodtype/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this exsbperiodtype ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
